// Delta expression consts
export const SampleIndex_Latest = 'latest';
export const SampleIndex_LatestMinusOne = 'latest - 1';
export const SampleIndex_LatestMinusTwo = 'latest - 2';
export const SampleIndex_LatestMinusThree = 'latest - 3';
export const SampleIndex_LatestMinusFour = 'latest - 4';
export const SampleIndex_First = 'first';
export const SampleIndex_All = [SampleIndex_Latest,
    SampleIndex_LatestMinusOne,
    SampleIndex_LatestMinusTwo,
    SampleIndex_LatestMinusThree,
    SampleIndex_LatestMinusFour,
    SampleIndex_First];
//# sourceMappingURL=consts.js.map